import React from 'react';

interface SnackbarOptions {
    message: string;
    severity?: string;
}

interface SnackbarData {
    message: string;
    severity: string;
}

const useSnackbar = (): {
    showSnackbar: boolean;
    handleSnackbar: (props?: SnackbarOptions) => void;
    snackBarData: SnackbarData;
} => {
    const [showSnackbar, setShowSnackbar] = React.useState(false);
    const [snackBarData, setSnackBarData] = React.useState<SnackbarData>({
        message: '',
        severity: 'success'
    });

    const handleSnackbar = (props?: SnackbarOptions) => {
        if (props) {
            const severity = props.severity || 'success';
            const message = props.message;
            setShowSnackbar(true);
            setSnackBarData({ message, severity });
        } else {
            setShowSnackbar(false);
        }
    };

    return { showSnackbar, handleSnackbar, snackBarData };
};

export default useSnackbar;
